import React from "react";
import '../css/Music.css';

class Music extends React.Component {
    render () {
        return (
            <div className="display-music">
                <h1>Music</h1>
            </div>
        )
    }
}
export default Music;